angular.module('workflow.app')

.factory 'Translator', ($http, endpoints, $analytics, User) ->

  # Private methods

  resultTranslateField = (result, field) ->
    @translate result[field], result.language, (translated) ->
      result[field + 'Translated'] = translated

  resultTranslateExtra = (field, value, result) ->
    if not result.extraTranslated then result.extraTranslated = {}
    @translate value, result.language, (translated) ->
      result.extraTranslated[field] = translated

  resultTranslateExtras = ( result ) ->
    for field, value of result.extra
      resultTranslateExtra.call this, field, value, result


  # For usage of 'new class' see http://alxhill.com/blog/articles/angular-coffeescript/
  new class Translator
    translate: (text, language, callback) ->
      params =
        to: @getUserReadingLanguage()
        text: text
        is_query: false
        html: true

      req = $http.get(endpoints.Translate, {
        params: params,
        cache: true
        headers: {
          # Remove headers so that it's a simple CORS request
          # See: https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
          "X-Requested-With": undefined,
        }
      })
      req.success (data, status, headers, config) ->
        if data.error
          callback 'Sorry there was a problem translating the text'

          $analytics.eventTrack "Error translating result",
            category: "Error"
            label: data.error
        else
          callback data.translated_text

    shouldTranslate: (result) ->
      return User.translation_enabled and @languageNeedsTranslating result.language

    translateResult: (result) ->
      if @shouldTranslate result
        if result.title
          resultTranslateField.call this, result, 'title'
        if result.snippet
          resultTranslateField.call this, result, 'snippet'
        if result.extra
          resultTranslateExtras.call this, result

    translateResults: (results) ->
      for result in results
        @translateResult result

    getUserReadingLanguage: () ->
      return User.userprofile.reading_language?.iso_code or 'en'

    languageNeedsTranslating: (isoLanguage) ->
      for userLanguage in User.userprofile.languages
        if userLanguage.iso_code == isoLanguage
          return false

      isDifferentFromUserReadingLanguage = @getUserReadingLanguage() != isoLanguage
      isDifferentFromUserReadingLanguage
